module.exports = __webpack_public_path__ + "media/images/clia-e8b69f53.jpg";